import { render, staticRenderFns } from "./CatalogSort.vue?vue&type=template&id=17a417f6&scoped=true"
import script from "./CatalogSort.vue?vue&type=script&lang=ts"
export * from "./CatalogSort.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a417f6",
  null
  
)

export default component.exports